// extracted by mini-css-extract-plugin
export default {"app":"L5x0Fp","scrollable":"aVF3iR","postPageRoot":"xZVb1s"};